import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dark-header"
export default class extends Controller {
	connect() {
		this.header = document.getElementById('welcomeHeader');
		this.header.setAttribute('data-bs-theme', 'dark');
	}

	disconnect() {
		this.header.removeAttribute('data-bs-theme');
	}
}